import OpusLayer from "lib/classes/opuslayer";
import Vector2 from "lib/classes/vector2";

interface ExportedLegendProps {
	width:number,
	height:number,
	layerWidth:number,
	layerHeight:number,
	margin:number,
	imageSize:number
}

export default class ExportedLegend implements ExportedLegendProps {
	public width:number = 0;
	public height:number = 0;
	public layerWidth:number = 0;
	public layerHeight:number = 0;
	public margin:number = 5;
	public imageSize:number = 0;
	public offsetx:number = 0;
	public offsety:number = 0;
	public onDecorate:Function;
	
	public decorate:Function = function(opusLayer:OpusLayer, layerPos:Vector2) {
		this.onDecorate.bind(this)(opusLayer, layerPos);
	}
	
	constructor({width, height, layerWidth, layerHeight, margin, imageSize}:ExportedLegendProps) {
		this.width = width;
		this.height = height;
		this.layerWidth = layerWidth;
		this.layerHeight = layerHeight;
		this.margin = margin;
		this.imageSize = imageSize;
	}
}